import { Avatar, Group, Menu, Stack, Text, UnstyledButton } from "@mantine/core"
import { useMemo } from "react"

export type MenuItem = {
  label: string
  icon: React.ReactNode
  onClick: () => void
}

type User = {
  company: {
    name: string
  }
  email: string
  name: string
}

type Props = {
  user: User
  withAvatar?: boolean
  src?: string | null
  menuItems?: MenuItem[]
}

export const UserMenu = ({
  user,
  withAvatar = true,
  src,
  menuItems,
}: Props) => {
  const initials = useMemo(
    () =>
      user?.name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase(),
    [user?.name]
  )

  return (
    <Menu width="target">
      <Menu.Target>
        <UnstyledButton>
          <Group wrap="nowrap">
            <Stack gap={0}>
              <Text size="sm" fw={700}>
                {user.company.name}
              </Text>
              <Text>{user.email}</Text>
            </Stack>
            {withAvatar ? (
              src ? (
                <Avatar src={src} radius="xl" />
              ) : (
                <Avatar radius="xl">{initials}</Avatar>
              )
            ) : null}
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {menuItems &&
          menuItems.map((item, index) => (
            <Menu.Item
              key={index}
              leftSection={item.icon}
              onClick={item.onClick}
            >
              {item.label}
            </Menu.Item>
          ))}
      </Menu.Dropdown>
    </Menu>
  )
}
